import { render, staticRenderFns } from "./PlanEdit.vue?vue&type=template&id=64afcade&scoped=true&"
import script from "./PlanEdit.vue?vue&type=script&lang=js&"
export * from "./PlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64afcade",
  null
  
)

export default component.exports